import React from 'react';

const BrandScroller = () => {
  const brands = [
    "Millet Amma", "Zigly", "Nike Camp", "Greenpeace", "JWL", "Vivek Lohia",
    "JEM", "LSBF", "HSBC Mutual Fund", "Canara HSBC Life", "Instax", "Nova Fertility",
    "Sattva Global", "Bhartiya City", "Arbour Investments", "Modulus",
    "Flipkart Wholesale", "Sakra Hospitals", "TownBus", "GRB Ghee", "BirthRight",
    "Sodexo", "Kotak MF", "Phoenix Group", "Loans24", "Insure24", "Dabur",
    "Elver", "Wella", "Vitabiotics", "Wellman", "CBRE", "East Bengal Club",
    "Coolberg", "10X International School", "OneFineRate", "Teeth-a-bit",
    "India Shelter", "Delfrez", "Green and Beige", "Sephora", "Reliance Trends",
    "10X Retail", "MintGenie", "Macaw Paints", "Orra", "Fenesta", "MoneyView",
    "JIRAAF", "Star Union Dai-ichi", "TVS Credit", "DesmondJi"
  ];

  // Top clients displayed as text (industry standard — W+K, R/GA, Droga5 style)
  const topBrands = [
    "HSBC Mutual Fund", "Canara HSBC Life", "Flipkart Wholesale", "Dabur",
    "Kotak MF", "Reliance Trends", "Sodexo", "CBRE",
    "BirthRight", "Fenesta", "Wella", "Greenpeace"
  ];

  // Split brands into two rows for a two-line ticker
  const mid = Math.ceil(brands.length / 2);
  const row1 = brands.slice(0, mid);
  const row2 = brands.slice(mid);

  const BrandPill = ({ name }) => (
    <span
      className="inline-block flex-shrink-0 px-6 py-2.5 mx-3 rounded-full border whitespace-nowrap transition-all duration-300 hover:scale-105"
      style={{
        borderColor: 'var(--border-color)',
        backgroundColor: 'var(--card-bg)',
        color: 'var(--text-secondary)',
        fontFamily: 'Nohemi, sans-serif',
        fontSize: '0.875rem',
        fontWeight: 500,
      }}
    >
      {name}
    </span>
  );

  return (
    <div className="relative" data-testid="brand-scroller">
      {/* Top clients — text grid (W+K/R/GA editorial style) */}
      <div className="mb-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-12 gap-y-6 max-w-4xl mx-auto text-center">
          {topBrands.map((name, index) => (
            <div
              key={index}
              className="stagger-item"
              style={{ animationDelay: `${index * 0.06}s` }}
            >
              <span
                className="text-base md:text-lg font-medium transition-opacity duration-300 hover:opacity-50"
                style={{ color: 'var(--text-primary)', fontFamily: 'Nohemi, sans-serif' }}
              >
                {name}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Two-row infinite ticker — slow, readable */}
      <div className="space-y-3">
        {/* Row 1 — scrolls left */}
        <div className="overflow-hidden relative">
          <div className="absolute left-0 top-0 bottom-0 w-20 z-10" style={{ background: 'linear-gradient(to right, var(--bg-secondary), transparent)' }} />
          <div className="absolute right-0 top-0 bottom-0 w-20 z-10" style={{ background: 'linear-gradient(to left, var(--bg-secondary), transparent)' }} />
          <div className="flex brand-ticker-left">
            {[...row1, ...row1, ...row1].map((name, i) => (
              <BrandPill key={`r1-${i}`} name={name} />
            ))}
          </div>
        </div>

        {/* Row 2 — scrolls right (reverse) */}
        <div className="overflow-hidden relative">
          <div className="absolute left-0 top-0 bottom-0 w-20 z-10" style={{ background: 'linear-gradient(to right, var(--bg-secondary), transparent)' }} />
          <div className="absolute right-0 top-0 bottom-0 w-20 z-10" style={{ background: 'linear-gradient(to left, var(--bg-secondary), transparent)' }} />
          <div className="flex brand-ticker-right">
            {[...row2, ...row2, ...row2].map((name, i) => (
              <BrandPill key={`r2-${i}`} name={name} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandScroller;
